module.exports = __webpack_public_path__ + "static/media/PluseIcon.aca75608.svg";